import { render, staticRenderFns } from "./PrintReceiptDejTab.vue?vue&type=template&id=6f5a8b01&scoped=true&"
import script from "./PrintReceiptDejTab.vue?vue&type=script&lang=js&"
export * from "./PrintReceiptDejTab.vue?vue&type=script&lang=js&"
import style0 from "./PrintReceiptDejTab.vue?vue&type=style&index=0&id=6f5a8b01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a8b01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRadio,VRadioGroup,VRow})
